<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>event_available</mat-icon> {{isEdit ? 'Einsatz bearbeiten' : 'Einsatz planen'}}
</h2>

<mat-dialog-content class="dialog-content">
  <div class="section-label"><mat-icon class="sk-inline-icon">groups</mat-icon> Wer arbeitet?</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Verantwortlich (z.B. Vorarbeiter)</mat-label>
    <mat-select [(ngModel)]="assignedUserId" required>
      <mat-option *ngFor="let u of data.users" [value]="u.id">{{userLabel(u)}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>person</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Weitere Beteiligte (Team)</mat-label>
    <mat-select [(ngModel)]="participantUserIds" multiple>
      <mat-option *ngFor="let u of data.users" [value]="u.id">{{userLabel(u)}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>groups</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="(data.workers ?? []).length > 0">
    <mat-label>Arbeiter (ohne Login)</mat-label>
    <mat-select [(ngModel)]="workerIds" multiple>
      <mat-option *ngFor="let w of data.workers" [value]="w.id">{{w.name}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>construction</mat-icon>
  </mat-form-field>

  <div class="section-label"><mat-icon class="sk-inline-icon">schedule</mat-icon> Wann?</div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Datum</mat-label>
      <input matInput type="date" [(ngModel)]="startDate" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Von</mat-label>
      <input matInput type="time" [(ngModel)]="startTime" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Bis</mat-label>
      <input matInput type="time" [(ngModel)]="endTime" required>
    </mat-form-field>
  </div>

  <div class="sk-filter-chips preset-row">
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','16:00')"
            (click)="setTimes('07:00','16:00')">Ganztag 07–16</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','12:00')"
            (click)="setTimes('07:00','12:00')">Vormittag 07–12</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('12:00','17:00')"
            (click)="setTimes('12:00','17:00')">Nachmittag 12–17</button>
  </div>

  <div class="section-label"><mat-icon class="sk-inline-icon">location_on</mat-icon> Wo &amp; Details</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel</mat-label>
    <input matInput [(ngModel)]="title" [placeholder]="data.auftrag.title">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Einsatzort</mat-label>
    <input matInput [(ngModel)]="location">
    <mat-icon matPrefix>location_on</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notizen</mat-label>
    <textarea matInput [(ngModel)]="notes" rows="2"></textarea>
  </mat-form-field>

  <div class="section-label"><mat-icon class="sk-inline-icon">handyman</mat-icon> Material (ohne Preise)</div>

  <div class="material-row" *ngFor="let m of materials; let i = index">
    <mat-form-field appearance="outline" class="material-name">
      <mat-label>Material</mat-label>
      <input matInput [(ngModel)]="m.name" placeholder="z.B. Schalung">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-qty">
      <mat-label>Menge</mat-label>
      <input matInput type="number" min="0" step="0.5" [(ngModel)]="m.quantity">
    </mat-form-field>
    <mat-form-field appearance="outline" class="material-unit">
      <mat-label>Einheit</mat-label>
      <mat-select [(ngModel)]="m.unit">
        <mat-option value="Stk">Stk</mat-option>
        <mat-option value="m">m</mat-option>
        <mat-option value="m²">m²</mat-option>
        <mat-option value="m³">m³</mat-option>
        <mat-option value="kg">kg</mat-option>
        <mat-option value="t">t</mat-option>
        <mat-option value="l">l</mat-option>
        <mat-option value="Pal">Pal</mat-option>
        <mat-option value="Pkg">Pkg</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="removeMaterial(i)" matTooltip="Entfernen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <button mat-stroked-button class="add-material" (click)="addMaterial()">
    <mat-icon>add</mat-icon> Material hinzufügen
  </button>

  <mat-checkbox [(ngModel)]="sendInvite">
    Kalender-Einladung (Outlook/.ics) an die Beteiligten senden
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !valid">
    <mat-icon *ngIf="!saving">event_available</mat-icon>
    {{isEdit ? 'Speichern' : 'Einplanen'}}
  </button>
</mat-dialog-actions>
